export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-01.c3c3d2f7.png";